export default {
  sessionStatus: {
    PENDING: "In Progress",
    CONFIRMED: "Confirmed",
    EXPIRED: "Expired",
    CANCELLED: "Cancelled",
  },
  messageStatus: {
    DELIVERED: "Delivered",
    BLOCKED: "Blocked",
  },
  sender: {
    CUSTOMER: "Customer",
    SELLER: "Seller",
    ADMIN: "Staff",
    SYSTEM: "System",
  },
  channel: {
    WHATSAPP: "WhatsApp",
    SMS: "SMS",
    EMAIL: "Email",
  },
  messageInput: {
    send: "Send",
  },
  bubble: {
    agreementDetected: "Agreement detected",
  },
  audit: {
    blockReason: "Block Reason",
    gptAnalysis: "Analysis metadata",
    sent: "Sent",
    notSent: "Not sent",
    internalNote: "Internal (not sent to customer)",
    viaChannel: "via {{channel}}",
  },
  listItem: {
    agreementReached: "✅ Agreement reached",
  },
  filters: {
    allSellers: "All sellers",
    panelTitle: "Filters",
    clearAll: "Clear all",
    status: "Status",
    channel: "Channel",
    customerName: "Customer Name",
    customerNamePlaceholder: "Search by customer name…",
    dateRange: "Date Range",
    from: "From",
    to: "To",
    seller: "Seller",
    clear: "Clear",
    search: "Search",
  },
} as const;
